import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteRequest } from 'api/base';
import { recordingObjectionKeys } from 'hooks/useRecordingObjectionStatus';
import type { RecordingObjectionStatus } from 'types/recordingObjection';
import { trackError } from 'utils/trackError';

export function useRevokeObjection(medatixxPatientId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<RecordingObjectionStatus, Error, void>({
    mutationFn: () =>
      deleteRequest('recordingObjection', undefined, {
        medatixxPatientId,
      }) as Promise<RecordingObjectionStatus>,
    onSuccess: (status) => {
      queryClient.setQueryData(recordingObjectionKeys.status(medatixxPatientId), status);
    },
    onError: (error) => {
      trackError(error, { context: 'revokeObjection' });
    },
  });
}
